module.exports = __webpack_public_path__ + "static/logo_ukraine-2a801be5f28951095ddb307110e2f583.svg";